import React from 'react';

class Covid extends React.Component {
	render() {
		return(

			<div>
				<div className="navbar-top">
		          <div className="site-brand">
		            <div className="side-nav-panel-left">
			            <a href="/"> 
			              <i className="fa fa-arrow-left" style={{fontSize: '21px',color: '#F0592D', paddingRight: '8px'}}></i>
			            </a>
		            </div>
		          </div>
		          <div className="site-brand">
		            <a href="/"> 
		              <h2><span className="st2">XPRESS</span><span className="st1">Lite</span></h2>
		            </a>
		          </div>
		          
		        </div>
                <div className="pages section">
					<div className="container">
						<div className="assetsdownload">
							<div className="assetsdownload-content">
								
                    <h6 className="heading-top">Advisory on Coronavirus Prevention</h6>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Special Bulletins on Facts and Prevention of Coronavirus (October-2020)

                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/ioclxpress/Consolidated_Bulletin_October_2020.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Hindi Translation of FAQ on COVID 19

                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/ioclxpress/Hindi_Frequently_asked_questions_on_Covid_19.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>



                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      IndianOil Covid Analysis - Volume 4

                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com//uploads/XpressNews/IndianOil_Covid_Analysis_Volume_4.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      IndianOil Covid Analysis - Volume 3

                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com//uploads/XpressNews/IndianOil_Covid_Analysis_Volume_3.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Action plan for resuming operations during COVID-19 pandemic

                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com//uploads/ioclxpress/PPT_2_2020.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>


                  	<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      New Covid-19 advisory

                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com/uploads/ioclxpress/Cosolidated_Advisory_new180420.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Chairman's Message on Aarogya Setu App
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com//uploads/ioclxpress/Chairman_Arogya090420.mp4" download="">Download / View Video</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>


                    
				


                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Message of Director(Refineries) on Aarogya Setu App

                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com/uploads/ioclxpress/Aarogya_setu_app_mailer090420.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Consolidated Advisory to prevent the spread of Novel Corona Virus (Hindi)
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com/uploads/ioclxpress/Cosolidated_Advisory_Hindi.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      APPEAL from Chairman
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com//uploads/ioclxpress/charman_appeal.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>


					

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
					  Message of Chairman on Coronavirus (Covid-19)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com//uploads/ioclxpress/Sanjiv_Singh_Chairman_IndianOil_mgs_covind-19.mp4" download="">Download / View Video</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
					
					

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Message from Director (R&D) on COVID-19
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com/uploads/ioclxpress/Message_from_Director_RnD_on_COVID-19_310320.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
					
					

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Message of Director (Pipelines) on Covid -19
  
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com//uploads/ioclxpress/Director_PL_message_25-20.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
					
					

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Message of Director (Marketing) on Covid -19

                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com//uploads/ioclxpress/Director_PL_message_25-20.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
					
					

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Message of Director (HR) on Coronavirus (Covid-19)

                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com//uploads/ioclxpress/DHR_MESSAGE_2020-03-20.mp4" download="">Download / View Video</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
					

					
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Message of Director (HR) on Coronavirus (Covid-19)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com//uploads/ioclxpress/DHR_Message_CoronaVirus.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>

                    
					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Message of Director (HR) on Coronavirus
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com/uploads/ioclxpress/Director_HR_IndianOil170320.mp4" download="">Download / View Video</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Consolidated Advisory to prevent the spread of Novel Corona Virus
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com/uploads/ioclxpress/Consolidated_Advisory_to_prevent_the_spread_of_Novel_Corona_Vir.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                     <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Special Bulletins on Facts and Prevention of Coronavirus (September-2020)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com/uploads/ioclxpress/Consolidated_Bulletin_September2020.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Special Bulletins on Facts and Prevention of Coronavirus (August-2020)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com/uploads/ioclxpress/corona_merged_August.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Special Bulletins on Facts and Prevention of Coronavirus (July-2020)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com/uploads/ioclxpress/corona_merged_July.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>


                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Special Bulletins on Facts and Prevention of Coronavirus (June-2020)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com/uploads/ioclxpress/corona_merged_Jun.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>


                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Special Bulletins on Facts and Prevention of Coronavirus  (May-2020)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com/uploads/ioclxpress/corona_merged_May.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    
                    
					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Special Bulletins on Facts and Prevention of Coronavirus  (April-2020)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com/uploads/ioclxpress/corona_merged_April.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>

                    
					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Special Bulletins on Facts and Prevention of Coronavirus (March-2020)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://www.iocl.com//uploads/ioclxpress/corona_merged.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>




				  </div>	
						</div>
					</div>	
				</div>
		      
				<div id="fakeLoader"></div>

				<div className="footer" style={{position:'relative', width:'100%', bottom:'0',}}>
					<div className="container">
					<div className="copyright">
							<span>Copyright © IndianOilXpress</span><br/>
							<a href="https://www.facebook.com/IndianOilCorpLimited" target="_blank"><i class="fab fa-facebook-f"></i></a>
                <a href="https://twitter.com/indianOilcl" target="_blank"><i class="fab fa-twitter"></i></a>
                <a href="https://www.youtube.com/channel/UC5ho18VZHwEFSahW0Q_o-6g/feed" target="_blank"><i class="fab fa-youtube"></i></a>
				<a href="https://www.instagram.com/indianoilcorp" target="_blank"><i class="fab fa-instagram"></i></a>
				<a href="https://www.linkedin.com/company/indian-oil-corp-limited" target="_blank"><i class="fab fa-linkedin-in"></i></a>
				
						</div>
					</div>
				</div>

			</div>

		)
	}
}

export default Covid;


// WEBPACK FOOTER //
// ./src/Covid.js